import { isDefined } from '@sgme/fp';
import classNames from 'classnames';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { TextListValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC, Fragment } from 'react';
import { camelCaseToWords } from 'utils/string';

export interface ProductSummaryTextListFieldProps {
  node: TextListValueDefinition;
}

export const ProductSummaryTextListField: FC<ProductSummaryTextListFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);
  const translationKey = node.translationKey ?? node.id;
  const isHighlighted = node.isHighlighted ?? false;
  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p
        className={classNames('text-large m-0', {
          'fw-light': !isHighlighted,
          'fw-bold': isHighlighted,
          'text-danger': isHighlighted,
        })}
        data-e2e={`product-summary-field-${node.id}`}
      >
        {isDefined(data) &&
          data.length > 0 &&
          data.map((text, index) => (
            <Fragment key={index}>
              {index > 0 && <br />}
              <FormattedMessage id={`field.${text}` as IntlKey} defaultMessage={camelCaseToWords(text)} />
            </Fragment>
          ))}
      </p>
    </SummaryFieldRow>
  );
};
